// src/sections/WartungSection.jsx
import { useState, useEffect } from "react";
import { Box, Heading, VStack, Input, Button, Field } from "@chakra-ui/react";
import axios from "axios";
import { showSuccess, showError } from "../utils/toastUtils";

export default function WartungSection({ selectedAnlageId }) {
  const [form, setForm] = useState({
    id: null,
    jahrErsteWartung: "",
    artDerWartung: "",
    wartungsturnus: "",
  });

  // ✅ load wartung when anlageId changes
  useEffect(() => {
    if (!selectedAnlageId) return;

    const loadWartung = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/wartung/anlage/${selectedAnlageId}`
        );

        setForm({
          id: res.data.id,
          jahrErsteWartung: res.data.jahrErsteWartung ?? "",
          artDerWartung: res.data.artDerWartung ?? "",
          wartungsturnus: res.data.wartungsturnus ?? "",
        });
      } catch {
        // no wartung yet → reset form
        setForm({
          id: null,
          jahrErsteWartung: "",
          artDerWartung: "",
          wartungsturnus: "",
        });
      }
    };

    loadWartung();
  }, [selectedAnlageId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    try {
      const payload = {
        jahrErsteWartung: form.jahrErsteWartung || null,
        artDerWartung: form.artDerWartung,
        wartungsturnus: form.wartungsturnus,
        anlage: { id: selectedAnlageId },
      };

      if (form.id) {
        await axios.put(
          `${process.env.REACT_APP_API_URL}/api/wartung/${form.id}`,
          payload
        );
      } else {
        await axios.post(
          `${process.env.REACT_APP_API_URL}/api/wartung`,
          payload
        );
      }

      showSuccess("Erfolg!", "Wartung gespeichert.");
    } catch {
      showError("Fehler!", "Speichern fehlgeschlagen.");
    }
  };

  return (
    <Box 
      p={8} 
      bg="white" 
      borderRadius="xl" 
      boxShadow="md" 
      mt={6} 
      mb={10} 
      maxW="md"
    >
      <Heading fontSize="24px" mb={4}>
        Wartung
      </Heading>

      <VStack spacing={4} align="stretch">
        <Field.Root>
        <Field.Label fontSize="md" fontWeight="bold">Jahr der ersten Wartung</Field.Label>
          <Input
            name="jahrErsteWartung"
            type="number"
            min="2000"
            placeholder="Jahr der ersten Wartung"
            value={form.jahrErsteWartung}
            onChange={handleChange}
          />
        </Field.Root>

        <select
          name="artDerWartung"
          value={form.artDerWartung}
          onChange={handleChange}
        >
          <option value="">Art der Wartung</option>
          <option value="Wartung">Wartung</option>
          <option value="Wartung & Monitoring">Wartung & Monitoring</option>
          <option value="Monitoring">Monitoring</option>
        </select>

        <select
          name="wartungsturnus"
          value={form.wartungsturnus}
          onChange={handleChange}
        >
          <option value="">Wartungsturnus</option>
          <option value="Erst-Wartung">Erst-Wartung</option>
          <option value="Einmalig">Einmalig</option>
          <option value="Jährlich">Jährlich</option>
          <option value="Zwei-Jährlich">Zwei-Jährlich</option>
          <option value="dguv v3 prüfung">DGUV V3 Prüfung</option>
        </select>

        <Button
          bg="#B8860B"
          color="white"
          _hover={{ bg: "#C99414" }}
          size="md"
          onClick={handleSave}
        >
          Speichern
        </Button>
      </VStack>
    </Box>
  );
}